@let email = selectors.email | select:'';
<mat-card class="max-w-[25rem]">
  <mat-card-content class="flex flex-col gap-y-3">
    <div class="text-headline-large">Verify Email</div>
    <div class="text-body-large">
      <p>An email was sent to:</p>
      <p>{{ email }}</p>
      <p>Please enter the six-digit verification code below:</p>
    </div>
    <mx-input-form-field fieldName="verificationCode" [externalLabel]="true" overrideLabel="Verification Code"
                         [formGroup]="verifyForm"/>
    <mx-filled-button label="Submit" [enabled]="verifyForm.valid" (click)="onClickNext()"/>
    <div>
      Didn't receive an email?
      <button class="link-button" (click)="onClickResend()" [disabled]="recentlySent">Resend email</button>
      @if (recentlySent) {
        <mat-error>Please wait a moment to resend the email.</mat-error>
      }
    </div>

  </mat-card-content>
</mat-card>
<div class="max-w-[50%] overflow-hidden ml-4">
  <img ngSrc="/assets/registration/verify-email.png" priority width="472" height="540" alt=""
       class="hidden md:flex md:max-w-[20rem] lg:max-w-[29.5rem]"/>
</div>
